// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3QtmY","upload":"Small_upload__2sCcW","imageWrap":"Small_imageWrap__1OHYy","removeBtn":"Small_removeBtn__2C5cL"};